import { z } from 'zod';
export const lvnSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        evaluation: z.object({
            arrivesAsScheduled: z.string().min(1, 'required'),
            followsPOC: z.string().min(1, 'required'),
            positiveAttitude: z.string().min(1, 'required'),
            reportsChanges: z.string().min(1, 'required'),
            useUniversalPrecautions: z.string().min(1, 'required'),
            ptConditionChanges: z.string().min(1, 'required'),
            ptSatified: z.string().min(1, 'required'),
            comments: z.string().optional(),
        }),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
